import { render, staticRenderFns } from "./articleResult.vue?vue&type=template&id=213f2ccd"
import script from "./articleResult.vue?vue&type=script&lang=js"
export * from "./articleResult.vue?vue&type=script&lang=js"
import style0 from "./articleResult.vue?vue&type=style&index=0&id=213f2ccd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports